module.exports = __webpack_public_path__ + "static/media/virus-card.8c6bc400.wav";